export default {"src":"/_next/static/media/empty-search-list.16258f1a.svg","height":162,"width":162,"blurWidth":0,"blurHeight":0};